// Global axios interceptor to attach Bearer token from localStorage on all requests.
// This makes auth work in browsers that block cookies (Brave, Safari Private mode, etc.).
import axios from 'axios';

const TOKEN_STORAGE_KEY = 'notaria90_access_token';

let installed = false;

export function installAxiosInterceptor() {
  if (installed) return;
  installed = true;

  axios.interceptors.request.use((config) => {
    try {
      const token = localStorage.getItem(TOKEN_STORAGE_KEY);
      if (token) {
        config.headers = config.headers || {};
        // Don't override an explicit Authorization header
        if (!config.headers.Authorization) {
          config.headers.Authorization = `Bearer ${token}`;
        }
      }
    } catch (err) {
      // localStorage may be unavailable (private mode, sandboxed iframe…)
      console.warn('[axios] could not read auth token:', err?.message || err);
    }
    return config;
  });
}
